"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LobbyStatusWindow;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _LobbyStatusWindowModule = _interopRequireDefault(require("./LobbyStatusWindow.module.scss"));

var _Button = _interopRequireDefault(require("../../../inputElements/Button/Button"));

var _EButtonType = _interopRequireDefault(require("../../../inputElements/Button/EButtonType"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var BARBARIAN = {
  vitality: 11,
  intelligence: 7,
  strength: 11,
  dexterity: 9
};
var HIGHELF = {
  vitality: 7,
  intelligence: 13,
  strength: 7,
  dexterity: 11
};
var WOODELF = {
  vitality: 8,
  intelligence: 11,
  strength: 7,
  dexterity: 12
};

function LobbyStatusWindow(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  var _useState = (0, _react.useState)(6),
      _useState2 = _slicedToArray(_useState, 2),
      points = _useState2[0],
      setPoints = _useState2[1];

  var _useState3 = (0, _react.useState)({
    vitality: 42,
    // TODO: initial/minimum values are depending on race
    intelligence: 43,
    strength: 44,
    dexterity: 45
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      mainAttributes = _useState4[0],
      setMainAttributes = _useState4[1];

  var incrementStat = (0, _react.useCallback)(function (entry) {
    var inrement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var newValue = mainAttributes;

    switch (entry) {
      case "VIT":
        newValue.vitality += inrement;
        break;

      case "INT":
        newValue.intelligence += inrement;
        break;

      case "STR":
        newValue.strength += inrement;
        break;

      case "DEX":
        newValue.dexterity += inrement;
        break;

      default:
        throw new Error("Unknown main attribute '".concat(JSON.stringify(entry), "'."));
    }

    setMainAttributes(newValue);
  }, [mainAttributes]);
  var autoDispatch = (0, _react.useCallback)(function () {
    if (points <= 0) return;
    var leftOverPoints = points;

    while (leftOverPoints > 0) {
      // TODO: increase values clockwise, starting at VIT
      leftOverPoints = 0;
    }

    setPoints(0);
  }, [points]);
  var renderEntry = (0, _react.useCallback)(function (entry) {
    var value = 0;

    switch (entry) {
      case "VIT":
        value = mainAttributes.vitality;
        break;

      case "INT":
        value = mainAttributes.intelligence;
        break;

      case "STR":
        value = mainAttributes.strength;
        break;

      case "DEX":
        value = mainAttributes.dexterity;
        break;

      default:
        throw new Error("Unknown main attribute '".concat(JSON.stringify(entry), "'."));
    }

    return /*#__PURE__*/_react.default.createElement("div", {
      className: _LobbyStatusWindowModule.default[entry]
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: _LobbyStatusWindowModule.default.decrease,
      type: _EButtonType.default.LEFT,
      onClick: function onClick() {
        incrementStat(entry, -1);
      }
    }, "\xA0"), /*#__PURE__*/_react.default.createElement("div", {
      className: _LobbyStatusWindowModule.default.value
    }, value), /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: _LobbyStatusWindowModule.default.increase,
      type: _EButtonType.default.RIGHT,
      onClick: function onClick() {
        incrementStat(entry);
      }
    }, "\xA0"));
  }, [mainAttributes, incrementStat]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_LobbyStatusWindowModule.default.window, className),
    style: style
  }, renderEntry("VIT"), renderEntry("INT"), renderEntry("STR"), renderEntry("DEX"), /*#__PURE__*/_react.default.createElement("div", {
    className: _LobbyStatusWindowModule.default.availablePoints
  }, points), /*#__PURE__*/_react.default.createElement("div", {
    className: _LobbyStatusWindowModule.default.autoDispatchBtn
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.AUTO_DISPATCH,
    onClick: autoDispatch
  })));
}